import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useIntl } from "react-intl";
import Spinner from "../../components/sharedComponents/Spinner";

export default function MicrosoftCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { messages } = useIntl();

  useEffect(() => {
    const status = searchParams.get("status");
    const message = searchParams.get("message");

    if (status === "success") {
      toast.success(
        messages["Microsoft_connected_success"] || "Microsoft account connected"
      );
    } else {
      toast.error(
        message ||
          messages["Microsoft_connected_error"] ||
          "Failed to connect Microsoft account"
      );
    }


    const returnTo = localStorage.getItem("ms_return_to") || "/profile";
    localStorage.removeItem("ms_return_to");
    navigate(returnTo, { replace: true });
  }, [navigate, searchParams, messages]);


  return <Spinner />;
}
